import React from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form, Input } from "antd";
//style
import styles from "./form.module.css";
const { Panel } = Collapse;

const SecretKeyManagerForm = ({ disabledState }) => {
  return (
    <Collapse defaultActiveKey={["secret_key_manager_1"]} expandIconPosition="end">
      <Panel header="Secret Key Manager" key="secret_key_manager_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="secret_key_manager_solution_access"
                  valuePropName="checked"
                >
                  <Switch disabled={disabledState} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default SecretKeyManagerForm;
